var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mb-1 pa-0"},[(_vm.item?.presetName)?_c(_vm.widgets[_vm.item.name],{tag:"component",attrs:{"widgetData":_vm.item}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }